module.exports = __webpack_public_path__ + "img/Professional-1.480d7805.png";